module.exports = __webpack_public_path__ + "assets/eeeee12a15f5b5f9c0e16a2ec14b3198.png";